import React, { FC, useEffect, useState } from "react";
import {
  DataGridPro,
  GridCellParams,
  GridColDef,
  GridDensity,
  GridRenderCellParams,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import { TableProps } from "../types";
import { Button, TablePagination } from "@mui/material";
import { apiClient } from "api";
import TableMenu from "./components/TableMenu";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store/types";

import { addCurrentColumns } from "store/table/table.slice";
import Download from "assets/Icons/salesViewAndReports/Download.svg";
import { MUI_TABLE_STYLES, TABLE_PAGINATION_STYLES } from "constants/constants";
import { SalesReportsProps } from "api/types";
import { FilterSharp, WorkRounded } from "@mui/icons-material";
import { DateFormat } from "utils/utils";

const columns: GridColDef[] = [
  // { field: "reportId", headerName: "ID", width: 100, hide: true },
  {
    field: "seller_name",
    headerName: "Seller",
    minWidth: 10,
    flex: 1,
    disableColumnMenu: true,
    filterable: false,
    headerAlign: "center",
  },
  {
    field: "uploadDate",
    align: "center",
    headerName: "Date",
    flex: 1,
    minWidth: 50,
    disableColumnMenu: true,
    filterable: false,
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => DateFormat(params.value),
  },
  {
    field: "Action",
    align: "center",
    disableColumnMenu: true,
    filterable: false,
    headerName: "Action",
    flex: 1,
    minWidth: 50,
    headerAlign: "center",
    renderCell: (params: GridCellParams) => {
      return (
        <Button
          onClick={() => {
            apiClient.downloadReport(params.row.reportId).then((res) => {
              window.open(res, "_self");
            });
          }}
          size="small"
          style={{ backgroundColor: "transparent" }}
        >
          <img src={Download} alt="download_report_hover" />
        </Button>
      );
    },
  },
];

const SalesReportsTable: FC<TableProps> = ({ rows, isCheckbox, fetching }) => {
  const dispatch = useDispatch();
  const density = useSelector(
    (state: AppState) => state.table.density
  ) as GridDensity;
  const filters = useSelector((state: AppState) => state.table.columnFilters);
  const [pageSize, setPageSize] = useState<number>(25);
  const [page, setPage] = useState<number>(0);
  const apiRef = useGridApiRef();
  const [initialRows, setInitialRows] = useState<SalesReportsProps[]>([]);
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    apiRef.current.setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPageSize(parseInt(event.target.value, 10));
  };

  useEffect(() => {
    if (rows && rows.length) {
      setInitialRows(rows);
    }
  }, [rows]);

  useEffect(() => {
    if (filters?.length && filters[1].length) {
      setPage(0);
      apiRef.current.setPage(1);
    }
  }, [filters]);

  useEffect(() => {
    if (columns.length) {
      dispatch(
        addCurrentColumns(
          columns.filter(
            (item: GridColDef) =>
              item.field !== "seller_id" &&
              item.field !== "Action" &&
              item.field !== "uploadDate"
          )
        )
      );
    }
  }, [columns]);

  const CustomFooter = () => {
    return (
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}
        component="div"
        sx={TABLE_PAGINATION_STYLES}
        count={initialRows.length}
        showLastButton
        showFirstButton
        rowsPerPage={pageSize}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    );
  };

  return (
    <>
      <TableMenu disableUpload disableExpand />
      <DataGridPro
        components={{
          Footer: CustomFooter,
        }}
        apiRef={apiRef}
        rows={initialRows}
        sx={MUI_TABLE_STYLES}
        columns={columns}
        pageSize={pageSize}
        headerHeight={52}
        loading={fetching}
        density={density}
        checkboxSelection={isCheckbox ? true : false}
        pagination
        onSortModelChange={() => {
          setPage(0);
        }}
        sortingOrder={["asc", "desc"]}
      />
    </>
  );
};

export default SalesReportsTable;
